export const INVALID_DATE: string = "Invalid Date";